'use strict';

wbApp.controller('FCHomeCtrl', ['$scope', '$window', '$q', '$popover', '$timeout', '$filter', 'subjectsSvc', 'courseSvc', 'tenantInfo', 'urlUtils',
function ($scope, $window, $q, $popover, $timeout, $filter, subjectsSvc, courseSvc, tenantInfo, urlUtils) {

    $scope.tenantInfo = tenantInfo;
    $scope.levelZeroTitle = tenantInfo.franchiseLevels.length > 0
        ? tenantInfo.franchiseLevels[0].name
        : tenantInfo.friendlyName;

    $scope.supportSubjectLicenses = tenantInfo.isFranchiseCentral && tenantInfo.franchiseCentralSettings.supportSubjectLicenses;

    $scope.filteredCourses = [];
    $scope.groupsByAddress = [];
    $scope.markerControl = {};

    function onBoundsChanged() {
        if (dataReady) {
            bindModel($scope.subjects, $scope.courses);
        }
    }

    function setDefaultLocation() {
        $scope.$apply(function () {
            $scope.userAddress.location.latitude = 50.0755381;
            $scope.userAddress.location.longitude = 14.43780049999998;
        });
    }

    var dataReady = false;

    $scope.userAddress = {
        location: {},
        formattedAddress: ''
    };

    $scope.$watch('userAddress.location', function () {
        if (dataReady && $scope.userAddress.location.latitude && $scope.userAddress.location.longitude) {
            $scope.map.center.latitude = $scope.userAddress.location.latitude;
            $scope.map.center.longitude = $scope.userAddress.location.longitude;
            $scope.map.zoom = 10;
        }
    });

    $scope.map = {
        control: {},
        center: {
            latitude: 49.804333,
            longitude: 15.580293
        },
        zoom: 7,
        markerOptions: {
            labelContent: "",
            labelAnchor: "0 0",
            labelClass: "marker-labels"
        },
        events: { 'bounds_changed': onBoundsChanged }
    }

    $scope.subjects = $scope.supportSubjectLicenses
        ? subjectsSvc.getAllAsync()
        : subjectsSvc.getAllActiveFranchiseSubjects();

    $scope.courses = $scope.supportSubjectLicenses
        ? courseSvc.getFranchiseCourses()
        : { $promise: $q(function(resolve, reject) { resolve([]); } ) };

    $q.all([$scope.subjects.$promise, $scope.courses.$promise]).then(function () {
        dataReady = true;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                $scope.$apply(function () {
                    $scope.userAddress.location.latitude = position.coords.latitude;
                    $scope.userAddress.location.longitude = position.coords.longitude;
                })
            }, function (error) {
                setDefaultLocation();
            });
        } else {
            setDefaultLocation();
        }
    });

    $scope.windowOptions = {
        show: false,
        position: {
            lat: 51.5286416,
            lng: -0.1015987
        }
    };

    $scope.windowParams = {
    }

    $scope.closeWindow = function () {
        $scope.windowOptions.show = false;
    }

    $scope.onClick = function (marker, eventName, model) {

        var filteredModel = _.find($scope.groupsByAddress, { id: model.id });

        $scope.windowOptions.pixelOffset = new google.maps.Size(0, -30);
        $scope.windowOptions.position.lat = filteredModel.location.latitude;
        $scope.windowOptions.position.lng = filteredModel.location.longitude;

        $scope.windowParams.model = filteredModel;

        $scope.windowOptions.show = true;//!$scope.windowOptions.show;
    };

    $scope.filterOptions = {
        filterText: ""
    };

    function bindModel(subjects, courses) {
        if ($scope.supportSubjectLicenses)
        {
            return bindModelCourses(subjects, courses);
        }
        else
        {
            return bindModelSubjects(subjects);
        }
    }

    function bindModelSubjects(subjects) {
        var bounds = null;
        if ($scope.map.control.getGMap) {
            bounds = $scope.map.control.getGMap().getBounds();
        }

        var filteredSubjects = !!bounds
            ? _.filter(subjects, function (subject) {
                return bounds.contains(new google.maps.LatLng(subject.latitude, subject.longitude));
            })
            : subjects;        

        filteredSubjects = _.sortBy(
            $filter('filter')(filteredSubjects, $scope.filterOptions.filterText),
            ['tenantFriendlyName', 'formatedAddress', 'subjectName']);

        $scope.filteredCourses.length = 0;
        $scope.filteredCourses.push.apply($scope.filteredCourses, filteredSubjects);

        var addressGroups = _.groupBy(filteredSubjects, function (subject) {
            return '_' + subject.longitude + '_' + subject.latitude;
        });

        var grouping = [];
        for (var property in addressGroups) {
            var locations = addressGroups[property];
            var first = _.head(locations);
            grouping.push({
                id: property,
                location: {
                    latitude: first.latitude,
                    longitude: first.longitude
                },
                courses: locations
            });
        }

        $scope.groupsByAddress.length = 0;
        $scope.groupsByAddress.push.apply($scope.groupsByAddress, grouping);
    }


    function bindModelCourses(subjects, courses) {
        var subjectDict = _.keyBy(subjects, 'id');

        var bounds = null;
        if ($scope.map.control.getGMap) {
            bounds = $scope.map.control.getGMap().getBounds();
        }

        var filteredCourses = _.filter(courses, function (course) {
            var include = subjectDict[course.franchiseSubjectID].include;

            if (bounds && include) {
                var point = new google.maps.LatLng(course.classroomLocation.latitude, course.classroomLocation.longitude);
                include = include && bounds.contains(point);
            }

            return include;
        });

        filteredCourses = $filter('filter')(filteredCourses, $scope.filterOptions.filterText);

        var model = courseSvc.enhanceFranchiseCoursesAndsort(filteredCourses, tenantInfo);

        var newGroupsByAddress = courseSvc.breakFranchiseCoursesByAddress(filteredCourses);

        $scope.groupsByAddress.length = 0;
        $scope.groupsByAddress.push.apply($scope.groupsByAddress, newGroupsByAddress);
        
        $scope.filteredCourses.length = 0;
        $scope.filteredCourses.push.apply($scope.filteredCourses, model);
    }

    $scope.$watch('filterOptions.filterText', function () {
        bindModel($scope.subjects, $scope.courses);
    });

    function setSubjectIDsUrl() {
        if (!$scope.supportSubjectLicenses) {
            return;
        }

        var urlParam = '';

        angular.forEach($scope.subjects, function (s) {
            if (s.include) {
                if (!urlParam) {
                    urlParam = '' + s.id;
                } else {
                    urlParam = urlParam + '-' + s.id;
                }
            }
        });

        if (!!$window.history.pushState) {
            if (!urlParam) {
                $window.history.pushState("Filter ", "Filter", "/");
            } else {
                $window.history.pushState("Filter ", "Filter", "/?subjectIDs=" + urlParam);
            }
        }
    }

    $scope.onSubjectIncludeChange = function () {
        
        setSubjectIDsUrl();

        bindModel($scope.subjects, $scope.courses);
    }

    $q.all([$scope.subjects.$promise, $scope.courses.$promise]).then(function (data) {
        var subjects = data[0];
        var courses = data[1];

        var urlParam = urlUtils.getQueryParams()['subjectIDs'];
        var subjectIDs = [];
        if (!!urlParam) {
            subjectIDs = urlParam.split('-');
        }

        _.forEach(subjects, function (subject) {
            if (subjectIDs.length > 0) {
                if (!!_.find(subjectIDs, function(s) { return s == subject.id; } ))  {
                    subject.include = true;
                } else {
                    subject.include = false;
                }
            } else {
                subject.include = true;
            }
        });

        if (subjectIDs.length === 0) {
            setSubjectIDsUrl();
        }

        bindModel(subjects, courses);
    });

    $scope.showTeacherDetail = function (course, $event) {
        var myPopover = $popover(angular.element(document.querySelector('#popover' + course.courseID)), {
            title: course.teacherFullName,
            content: '<img class="teacher-photo-max" src="' + course.teacherPhotoUrl + '">',
            trigger: 'manual',
            autoClose: true,
            html: true
        });
        myPopover.$promise.then(function () {
           
            myPopover.toggle();
            $timeout(function () {
                myPopover.$applyPlacement();
            }, 10);
        });
    }

    $scope.rowSelected = function (row) {
        var markers = $scope.markerControl.getGMarkers();
        if (markers && markers.length) {
            var id = '_' + row.longitude + '_' + row.latitude;
            var marker = _.find(markers, { 'key': id });
            if (marker) {
                if (marker.getAnimation() != google.maps.Animation.BOUNCE) {
                    marker.setAnimation(google.maps.Animation.BOUNCE);
                    $timeout(function () {
                        marker.setAnimation(null);
                    }, 5000);
                }
            }
        }
    }

    if ($scope.supportSubjectLicenses) {
        $scope.gridOptions = {
            columnDefs: [
                         { field: 'placeName', displayName: "TXT_LAB_PLACE", sort: 'locale', width: '140px' },
                         { field: 'subjectName', displayName: "TXT_COL_SUBJECT", sort: 'locale', width: '140px' },
                         { field: 'courseName', displayName: "TXT_LAB_COURSE", sort: 'locale' },
                         { field: 'teacherSurname', displayName: "TXT_COL_TEACHER", sort: 'locale', width: '140px' },
                         { field: 'firstLessonStartDate', displayName: "TXT_LBL_BEGINING", cellFilter: 'date:dd.MM.yy', width: '75px' },
                         { field: 'firstLessonStartDate', displayName: "TXT_TITLE_SCHEDULE", cellFilter: 'date:EEE HH:mm', width: '75px', align: 'right' },
                         { field: 'courseUrl', displayName: "", width: '75px', cellFilter: 'urlButton', align: 'right', html: true },
            ],
            noCommandColumn: true,
            pageSize: 20,
            disableRowSelection: true,
            grouping: {
                enabled: true,
                isGroupRowPropertyName: 'isGroupRow',
                subItemsPropertyName: 'courses'
            }
        };
    } else {
        $scope.gridOptions = {
            columnDefs: [
                         { field: 'tenantFriendlyName', displayName: "TXT_NAME", sort: 'locale', width: '240px' },
                         { field: 'formatedAddress', displayName: "TXT_LAB_PLACE", sort: 'locale', width: '240px' },
                         { field: 'subjectName', displayName: "TXT_COL_SUBJECT", sort: 'locale' },
                         { field: 'tenantHost', displayName: "", width: '75px', cellFilter: 'urlButton', align: 'right', html: true },
            ],
            noCommandColumn: true,
            pageSize: 20,
            disableRowSelection: false,
        };

    }

}]);